export default __webpack_public_path__ + "static/media/ico-history-24.54adc0d2.svg";